<template>
    <div class="modal-content consents-modal">
        <div class="modal-header border-0 text-center">
            <div class="modal-title">
                <h2 class="h3 px-2 pt-4 pb-1">
                    Dołącz do M/platform – zyskaj dostęp do pełnych możliwości
                    Panelu
                </h2>
            </div>
        </div>
        <div
            class="modal-body pr-4 pl-4 pb-4 text-primary consents-modal__body"
        >
            <div class="tr-data mb-4 is-column">
                <div class="px-3">
                    <p class="typo typo--name mb-3">
                        Obecnie masz dostęp do wąskiej części funkcjonalności
                        oferowanych przez M/platform. Dołącz do ponad 12.000
                        sklepów, które już korzystają z naszego narzędzia i
                        zacznij zarabiać więcej!
                    </p>
                    <p class="typo mb-2">
                        Dzięki M/platform zyskasz dostęp do:
                        <ul>
                            <li>najlepszych promocji odsprzedażowych od topowych producentów z branży spożywczej,</li>
                            <li>sklepu internetowego do zamawiania towaru od Twoich dystrybutorów,</li>
                            <li>oraz aplikacji konsumenckiej z programem lojalnościowym.</li>

                        </ul>
                    </p>
                    <p class="typo mb-2">
                        Kliknij poniższy przycisk i zapoznaj się z pełną ofertą M/platform. Włączając usługę wyrażasz zgodę na kontakt naszego koordynatora i przedstawienie oferty przyłączenia do programu. Nasz przedstawiciel skontaktuje się z Tobą w terminie do trzech dni roboczych. Nie chcesz czekać? Skontaktuj się z nami pod numerem 22&nbsp;123&nbsp;84&nbsp;00.
                    </p>

                </div>

            </div>

            <div class="text-center mt-4">
                <the-btn
                    @click.native="closeModal"
                    :text="'Rozumiem'"
                    :btnClass="'btn-outline-custom flex-grow-1 btn-primary mx-3'"
                ></the-btn>
                <the-btn
                    @click.native="joinToMplatformClick"
                    :text="'Dołącz do M/platform'"
                    :btnClass="'btn-secondary flex-grow-1 btn-primary mx-3'"
                ></the-btn>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {}
    },
    methods: {
        async closeModal() {
            this.$store.dispatch('toggleModal', false)
        },
        joinToMplatformClick() {
            this.closeModal()
            const joinToMplatformService = this.$store.getters.getServices.find(
                service => service.code === 'mp_pp'
            )
            if (joinToMplatformService) {
                joinToMplatformService.id &&
                    this.$router.push({ name: 'service', params: { id: joinToMplatformService.id } })
            }
        }
    }
}
</script>
